import React, { useEffect, useState } from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import BaseCustomerTable from "../BaseCustomerTable/BaseCustomerTable";
import DynamicTable from "../DynamicTable/DynamicTable";

export default function OperatorTable({ operatorData, handleSelectedUser, targetID, systemRoles, userStatus }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);  
  const pageCount = Math.ceil(operatorData.length / rowsPerPage);
  const pageNumbers = Array.from({ length: pageCount }, (_, index) => index);
  const [operatorTable, setOperatorTable] = useState(null);

  // console.log(pageCount, pageNumbers)

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // console.log(operatorData)

  async function getTable() {
      let response = await fetch(`/tables/operatorTableNew.json`);
      // let response = await fetch(`/tables/operatorTable.json`);
      const tableData = await response.json();
      setOperatorTable(tableData);
      setRowsPerPage(tableData.rowsPerPage);
  }

  useEffect(() => {
    getTable();
  }, []);

  return (
    <>
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
          { operatorTable && 
          <DynamicTable
          tableData={operatorData}
          tableSource={operatorTable}
          page={page} 
          handleEdit={handleSelectedUser}
          targetID={targetID}
          twoColumn={false} 
          roles={systemRoles}
          userStatus={userStatus}
          />
          }
          <BaseCustomerTable
            page={page}
            onPageChange={handleChangePage}
            pageNumbers={pageNumbers}
          />
        </TableContainer>
    </>
  );
}
